<template>
  <!--  skeleton  -->
  <div v-if="isLoading" id="profile-collection-skeleton">
    <div class="mb-4">
      <div class="h-6 w-48 bg-grey-9 rounded animate-pulse"></div>
    </div>
    
    <div class="flex flex-col smd:flex-row gap-4 overflow-x-auto">
      <div 
        v-for="n in itemsCount" 
        :key="n" 
        class="profile-item-skeleton flex-shrink-0 flex flex-row smd:flex-col"
      >
        <div class="w-[44px] h-[44px] smd:w-[96px] smd:h-[96px] bg-grey-9 rounded-full animate-pulse smd:mb-2"></div>
        <div class="h-4 w-16 bg-grey-9 rounded animate-pulse mb-2"></div>
      </div>
    </div>
  </div>
  <div v-else-if="items.length > 0" id="profile-collection">
    <div id="profile-item-title">✨ <span>{{ $t('profile_collection.recommend') }}</span> ✨</div>
    <div id="profile-item-collection" class="flex">
      <div v-for="(profile, index) in items" :key="profile.id">
        <div class="profile-item">
          <a
            :href="'/' + this.locale + profile.public_path"
            class="block rounded-full overflow-hidden"
          >
            <img
              v-if="isFirstScreenProfile(index)"
              :src="profile.avatar_url"
              :alt="profile.brand_name"
              class="image"
              loading="eager" />
            <img
              v-else
              v-lazy="profile.avatar_url"
              :alt="profile.brand_name"
              class="image" />
          </a>
          <div class="profile-name w-full py-2">
            <div
              class="text-grey-5 text-12px truncate font-medium"
              :title="profile.brand_name"
            >
              {{ profile.brand_name }}
            </div>
          </div>
          <template v-if="profile.followable != null">
            <div
              v-if="profile.followable"
              class="follow-btn follow"
              @click="followBtnClick(profile, index)"
            >
              {{ $t('profile_collection.follow') }}
            </div>
            <div
              v-else
              class="follow-btn unfollow"
              @click="unfollowBtnClick(profile, index)"
            >
              {{ $t('profile_collection.following') }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUrlLocale } from '../utils/getUrlLocale';
import { isFirstScreenProfile } from '../utils/firstScreenCalculator';

const searchPath = "/api/v1/posts/recommand_creators";

export default {
  data() {
    return {
      isLoading: true,
      itemsCols: 8,
      itemsRows: 1,
      itemsCount: 8,
      items_not_found: false,
      items_data: [],
      items: [],
      locale: ''
    };
  },
  mounted() {
    this.setupQueryString();
    this.setupItemColsCount();
    this.fetchItemData();

    this.locale = getUrlLocale();

    window.addEventListener("resize", () => {
      this.setupItemColsCount();
      this.items = [];
      this.items.push(...this.items_data.slice(0, this.itemsCount));
    });
  },
  methods: {
    followModulePayload(profile, index, action) {
      return {
        page_type: 'listing',
        module: 'profile_collection',
        landing_path: window.location.pathname,
        target_type: 'follow_button',
        target_id: profile.username,
        position: index,
        action,
      };
    },
    followBtnClick(profile, index) {
      this.followCreator(profile, index);
    },
    unfollowBtnClick(profile, index) {
      this.unfollowCreator(profile, index);
    },
    trackFollowClick(profile, index, action) {
      if (window.trackingEvent) {
        window.trackingEvent.track_module_click(this.followModulePayload(profile, index, action));
      }
    },
    async followCreator(profile, index) {
      try {
        const url = "/api/v1/profiles/" + profile.username + "/follow";
        const response = await fetch(url, { method: "POST" });

        if (response.ok) {
          const data = await response.json();

          if (data.success) {
            const profileIndex = this.items.indexOf(profile);
            this.items[profileIndex].followable = false;
            this.trackFollowClick(profile, index, 'follow');
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async unfollowCreator(profile, index) {
      try {
        const url = "/api/v1/profiles/" + profile.username + "/unfollow"
        const response = await fetch(url, {method: 'DELETE'})

        if (response.ok) {
          const data = await response.json();

          if (data.success) {
            const profileIndex = this.items.indexOf(profile)
            this.items[profileIndex].followable = true
            this.trackFollowClick(profile, index, 'unfollow');
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchItemData() {
      try {
        let curr_params = {...this.current_params}
        // per_page 最低數量為4
        curr_params['per_page'] = 8

        const response = await fetch(searchPath + '?' + new URLSearchParams(curr_params));
        if (response.ok) {
          const data = await response.json();
          const itemsData = data['data']

          this.items = []
          this.items_data = []

          if (itemsData.length == 0) {
            this.items_not_found = true
          } else {
            this.items.push(...itemsData.slice(0, this.itemsCount));
            this.items_data.push(...itemsData);
          }
        }
      } catch (error) {
        this.items = [];
      } finally {
        this.isLoading = false
      }
    },
    setupQueryString() {
      const currParams = new URLSearchParams(window.location.search);
      const paramsObject = Object.fromEntries(currParams);

      this.current_params = paramsObject
    },
    setupItemColsCount() {
      if (window.innerWidth >= 1536) {
        this.itemsCols = 8
      }  else if (window.innerWidth >= 780) {
        this.itemsCols = 6
      } else if (window.innerWidth >= 705) {
        this.itemsCols = 5
      } else {
        this.itemsCols = 4
      }

      this.itemsCount = this.itemsCols * this.itemsRows
    },
    isFirstScreenProfile(index) {
      return isFirstScreenProfile(index);
    }
  }
};
</script>
